export const TableHelpers = {
  data() {
    return {
      tableColumns: [
        {
          title: this.$t("Año de Pago"),
          type: "custom-html",
          key: "year",
          modifier: (value) => {
            return value;
          },
        },
        {
          title: 'OEC',
          type: 'custom-html',
          key: 'organization',
          modifier: (value) => {
            return value.business_name;
          }
        },
        // {
        //   title: this.$t("Área"),
        //   type: "custom-html",
        //   key: "accreditation_application",
        //   modifier: (value) => {
        //     return value.accreditation_area.name;
        //   },
        // },
        {
          title: "Actividad",
          type: "custom-html",
          key: "accreditation_activity",
          modifier: (value) => {
            return value.name;
          },
        },
        {
          title: "Fecha de Aprobación",
          type: "custom-html",
          key: 'approved_date',
          modifier: (value) => {
              if (value) {
                  return moment(value).format("YYYY-MM-DD HH:mm");
              }
          },
        },
        {
          title: "Fecha de Caducidad",
          type: "custom-html",
          key: 'validity_date',
          modifier: (value) => {
              if (value) {
                  return moment(value).format("YYYY-MM-DD HH:mm");
              }
          },
        },
        {
          title: "Licencia",
          type: "custom-html",
          key: 'acc_app_id',
          modifier: (value) => {
              let tmp;
              if (value) {
                  tmp = `<span class="badge badge-sm badge-pill badge-secondary">ADQUISICIÓN</span>`;
              } else {
                  tmp = `<span class="badge badge-sm badge-pill badge-secondary">RENOVACIÓN</span>`;
              }

              return tmp;
          }
        },
        {
          title: "Aprobado",
          type: "custom-html",
          key: "is_approved",
          modifier: (value) => {
            if (value == 1) {
              return `<span class="badge badge-sm badge-pill badge-success">SI</span>`
            } else if (value == 0){
              return `<span class="badge badge-sm badge-pill badge-danger">NO</span>`
            } else {
              return `<span class="badge badge-sm badge-pill badge-warning">PENDIENTE</span>`
            }
          },
        },
        {
          title: "Estado",
          type: "custom-html",
          key: "validity_date",
          modifier: (value) => {
            if(value) {
              const dateNow = new Date();
              if (moment(dateNow).format() < moment(value).format()) {
                return `<span class="badge badge-sm badge-pill badge-success">VIGENTE</span>`
              } else {
                return `<span class="badge badge-sm badge-pill badge-danger">CADUCADO</span>`
              }
            } else {
              return '';
            }
            
          },
        }
      ],
      actionObj: {
        title: this.$t("action"),
        type: "action",
      },
    };
  },
};
